import React from 'react'
import cancelIcon from '../../assets/svg/Group 36.svg'
import backIcon from '../../assets/svg/Path 7.svg'
import nextIcon from '../../assets/svg/Path 6.svg'
export default function PageControls({nextPage, noNext, handleCancel, cancel}) {
    return (

                      <div className="pageControl">
                <div className="arrows">
                    <img src={nextIcon} onClick={() => nextPage(-1)} alt=""/>
                    {!noNext? 
                      <img src={backIcon} alt="" onClick={() => nextPage(1)} />
                    :''}
                </div>
                <img src={cancelIcon} onClick={() => {cancel ?handleCancel() : nextPage(-1)}} alt=""/>

            </div>

    )
}
